import { z } from 'zod'

export const WarehouseFormSchema = z.object({
  name: z.string().min(1, {
    message: 'warehouse.warehouses.form.name.required',
  }),
  code: z.string().min(1, {
    message: 'warehouse.warehouses.form.code.required',
  }),
  isActive: z.boolean().optional().default(true),
  isDefault: z.boolean().optional().default(false),
})

export type WarehouseFormValues = z.infer<typeof WarehouseFormSchema>
